import React from "react";
import "./SelectOption.css";

/**
 *
 * SelectOption
 * @param {object} props Component props
 * @prop {string} props.value Value of option
 * @prop {boolean} props.isSelected Describing if value is selected
 * @prop {function} [props.click] Click even that returns the value
 * @prop {ReactNode} props.children
 *
 */
export const SelectOption = ({ value, isSelected, click, children }) => {
  const classes = ["SelectOption"];

  if (isSelected) {
    classes.push("is-selected");
  }

  return (
    <div className={classes.join(" ")} onClick={() => click(value)}>
      {children}
    </div>
  );
};
